import React from 'react';
import { connect } from 'react-redux';
import { Container } from 'semantic-ui-react';
import { Media } from '../../../../mediaSetting.js';
import HtmlToReact from 'html-to-react';
import xss from 'xss';

import { ValidMe } from '../../../../businessLogic/validation.js';
import Txt from '../../../inputs/textInput.js';
import { updateWaitingAreaSmsNotificationForm } from '../../../../actions/waitingArea.js';
import { clone } from '../../../../reducers/helper.js';

require('../../../../../styles/arrowSlider/arrowSlider.scss');

let htmlToReactParser = new HtmlToReact.Parser(React);

@connect(mapStateToProps)
export default class CenterPanelCreateSmsNotification extends React.Component {
  constructor(props) {
    super(props);
  }

  waitingAreaSmsFormUpdated = (property, value) => {
    let val = value;
    var clonedWaitingAreaSmsNotificationForm = clone(this.props.waitingAreaSmsNotificationForm);
    property.map((option, i) => {
      clonedWaitingAreaSmsNotificationForm[option] = value[i];
    }, this);
    clonedWaitingAreaSmsNotificationForm.myProviderStatus = this.props.myProviderStatus;
    return clonedWaitingAreaSmsNotificationForm;
  };

  waitingAreaSecondsNotificationChange = (e) => {
    let value = '';
    if (typeof e != 'number') value = parseInt(e.target.value, 10);
    else value = e;
    if (!isNaN(value)) {
      if (value >= 0) {
        if (value > 99) {
          value = 99;
        }
        this.props.dispatch(
          updateWaitingAreaSmsNotificationForm(
            this.waitingAreaSmsFormUpdated(['secondsIntervalToSmsSendNotification'], [value])
          )
        );
      }
    }
    if (e.target && e.target.value == '') {
      value = 0;
      this.props.dispatch(
        updateWaitingAreaSmsNotificationForm(
          this.waitingAreaSmsFormUpdated(['secondsIntervalToSmsSendNotification'], [value])
        )
      );
    }
  };

  waitingAreaMobilePhoneNumberChanged = (value) => {
    this.props.dispatch(
      updateWaitingAreaSmsNotificationForm(this.waitingAreaSmsFormUpdated(['mobilePhoneNumber'], [value]))
    );
  };

  render() {
    let validationPhoneNumber = 'phoneNumber';
    return (
      <div className="ui form">
        <ValidMe validmefor={validationPhoneNumber} group="createWaitingAreaSmsNotificationForm">
          <Container
            fluid
            className="title-sms"
            as={Media}
            greaterThanOrEqual="mobile"
            htmlFor={APP.LANGUAGE.UpdateCreateSmsNotification.id}
          >
            {APP.LANGUAGE.UpdateCreateSmsNotification.Title}
          </Container>
          <Container
            fluid
            className="title-sms mrbm"
            as={Media}
            at="mobile"
            htmlFor={APP.LANGUAGE.UpdateCreateSmsNotification.id}
          >
            {APP.LANGUAGE.UpdateCreateSmsNotification.MobileTitle}
          </Container>
          <Txt
            tabIndex="1"
            focusme="true"
            id={APP.LANGUAGE.UpdateCreateSmsNotification.id}
            notRenderPlaceholderAsTitle={true}
            value={this.props.waitingAreaSmsNotificationForm.mobilePhoneNumber}
            onChange={this.waitingAreaMobilePhoneNumberChanged}
          />
        </ValidMe>
        <p className="warning-notification mrbxl mrts">
          <i className="ui icon warning circle" />
          <span>{htmlToReactParser.parse(xss(APP.LANGUAGE.UpdateCreateSmsNotification.WarningMessage))}</span>
        </p>
        <div className="mrtsss mxwdtmlpx span-like mrbnull field">
          <Txt
            onClick={this.props.selectText}
            upArrowAction={() => {
              this.waitingAreaSecondsNotificationChange(
                this.props.waitingAreaSmsNotificationForm.secondsIntervalToSmsSendNotification + 1
              );
            }}
            downArrowAction={() => {
              this.waitingAreaSecondsNotificationChange(
                this.props.waitingAreaSmsNotificationForm.secondsIntervalToSmsSendNotification - 1
              );
            }}
            arrowSlider
            value={this.props.waitingAreaSmsNotificationForm.secondsIntervalToSmsSendNotification}
            placeholder={APP.LANGUAGE.UpdateCreateSmsNotification.PhonePlaceholder}
            noTitle
            onChange={this.waitingAreaSecondsNotificationChange}
          />
        </div>
        <div className="right-hand-seconds-notification">
          <label>{APP.LANGUAGE.UpdateCreateSmsNotification.PlaceholderUpdateSmsNotificationSeconds}</label>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    waitingAreaSmsNotificationForm: state.waitingAreaReducer.waitingAreaSmsNotificationForm,
  };
}
